<div>
  <div class="img-container">
    <img src = "https://sonraianalytics.com/maintenance.png" class="responsive"  />
    <h2 class="text">We are performing important maintenance </h2>
    <hr>
    <h3 class="text">Updates typically take just a few minutes</h3>
    <h3 class="text">Contact <a class="link" href="mailto:support@sonraianalytics.com">support@sonraianalytics.com</a> if you require further information </h3>
  </div>
</div>